import request from '../request';

// 获取会员配置
export const getMemberConfig = (params) => {
  return request({
    url: '/v3/member_packages',
    method: 'get',
    params
  })
}
